import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@sw/api-client';
import {
  listTalentEvaluations,
  type ListEvaluationsParams,
} from './talentEvaluationsApi';

export const TALENT_EVALUATIONS_QUERY_KEY = ['talent', 'evaluations'] as const;

export function useTalentEvaluations(params: ListEvaluationsParams) {
  return useQuery({
    queryKey: [
      ...TALENT_EVALUATIONS_QUERY_KEY,
      params.shortlistPublicKey,
      params.talentPublicKey,
    ],
    queryFn: () => listTalentEvaluations(params),
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (error instanceof ApiError && error.status === 404) return false;
      return failureCount < 2;
    },
  });
}
